/**
 * 端末の設定・同意状態(CLAUDE.md §14)
 *
 * 同意しない場合もオフライン参加は可能。その場合はサーバー同期を無効化する。
 * device_id は匿名。氏名等の個人情報は一切扱わない。
 */

import { get, put, STORE } from "./db";
import { ulid } from "../lib/crypto";

const KEY = {
  deviceId: "device_id",
  syncConsent: "sync_consent",
  consentAt: "consent_at",
  installGuide: "install_guide_done",
} as const;

/** 端末の匿名ID。初回起動時に生成し、以後変えない。 */
export async function getDeviceId(): Promise<string> {
  const existing = await get<string>(STORE.settings, KEY.deviceId);
  if (existing) return existing;
  const id = ulid();
  await put(STORE.settings, id, KEY.deviceId);
  return id;
}

/** 未回答なら null。同意/拒否が明示的に選ばれていれば boolean。 */
export async function getSyncConsent(): Promise<boolean | null> {
  const v = await get<boolean>(STORE.settings, KEY.syncConsent);
  return v === undefined ? null : v;
}

export async function setSyncConsent(agreed: boolean): Promise<void> {
  await put(STORE.settings, agreed, KEY.syncConsent);
  await put(STORE.settings, new Date().toISOString(), KEY.consentAt);
}

/**
 * ホーム画面への追加の案内を済ませたか。
 *
 * 「追加した」と「あとにする を選んだ」を区別しない。案内を出し続けないことだけが
 * 目的で、実際に追加できたかは端末側から確実には分からない(iOSは通知がない)。
 */
export async function getInstallGuideDone(): Promise<boolean> {
  return (await get<boolean>(STORE.settings, KEY.installGuide)) === true;
}

export async function setInstallGuideDone(): Promise<void> {
  await put(STORE.settings, true, KEY.installGuide);
}
